import { ButtonFactoryProps } from "@components/Button/utils/types";
import { cn } from "@util/helpers";

export const btnPrimaryStyle = cn(
  "font-poppins text-white text-2xs px-6 py-4 bg-gray-850 rounded-[3rem] transition-colors !no-underline justify-center tracking-2%",
  "hover:bg-gray-850/95"
);

/** This is the primary button. */
const ButtonPrimary = ({
  className,
  text,
  icon,
  iconPosition = "right",
  onClick,
  type = "button",
  children,
}: ButtonFactoryProps): React.ReactElement => {
  if (!text && typeof icon === "undefined") return <></>;

  return (
    <button
      data-testid="button-primary-component"
      className={cn(
        btnPrimaryStyle,
        { "aspect-square p-[5px]": icon && typeof text === "undefined" },
        className
      )}
      onClick={onClick}
      type={type}
    >
      {children ? (
        children
      ) : (
        <>
          {iconPosition === "left" && icon ? icon : null}
          {text ? text : null}
          {iconPosition === "right" && icon ? icon : null}
        </>
      )}
    </button>
  );
};

export default ButtonPrimary;
